module.exports = __webpack_public_path__ + "static/sb_dlx-33f4dd097752bfb059e17f9bcdec2626.png";